import React, { useState } from 'react';
import { Plus, Trash2, HelpCircle, X } from 'lucide-react';

const SurveyBuilder = ({ surveyData, setSurveyData }) => {
  const [activeQuestionId, setActiveQuestionId] = useState(null);

  const addQuestion = () => {
    const newQuestion = {
        id: Date.now().toString(),
        text: '',
        type: 'radio',
        options: ['Opción 1', 'Opción 2']
    };
    setSurveyData({
        ...surveyData,
        questions: [...surveyData.questions, newQuestion]
    });
    setActiveQuestionId(newQuestion.id);
  };

  const removeQuestion = (id) => {
    setSurveyData({
        ...surveyData,
        questions: surveyData.questions.filter(q => q.id !== id)
    });
    if (activeQuestionId === id) setActiveQuestionId(null);
  };

  const updateQuestion = (id, field, value) => {
    setSurveyData({
        ...surveyData,
        questions: surveyData.questions.map(q => 
            q.id === id ? { ...q, [field]: value } : q
        )
    });
  };

  const addOption = (questionId) => {
    setSurveyData({
        ...surveyData,
        questions: surveyData.questions.map(q => {
            if (q.id === questionId) {
                return { ...q, options: [...q.options, `Opción ${q.options.length + 1}`] };
            }
            return q;
        })
    });
  };

  const removeOption = (questionId, index) => {
    setSurveyData({
        ...surveyData,
        questions: surveyData.questions.map(q => {
            if (q.id === questionId) {
                const newOptions = [...q.options];
                newOptions.splice(index, 1);
                return { ...q, options: newOptions };
            }
            return q;
        })
    });
  };

  const updateOption = (questionId, index, value) => {
    setSurveyData({
        ...surveyData,
        questions: surveyData.questions.map(q => {
            if (q.id === questionId) {
                const newOptions = [...q.options];
                newOptions[index] = value;
                return { ...q, options: newOptions };
            }
            return q;
        })
    });
  };

  return (
    <div className="survey-builder bg-light p-4 rounded mt-3 border border-info border-opacity-25">
      <div className="d-flex align-items-center mb-3 text-info">
        <HelpCircle size={20} className="me-2" />
        <h5 className="mb-0 fw-bold">Adjuntar Encuesta</h5>
      </div>
      
      <div className="mb-3">
        <label className="form-label small text-muted">Título de la Encuesta</label>
        <input 
            type="text" 
            className="form-control" 
            placeholder="Ej: Feedback de la clase de hoy"
            value={surveyData.title}
            onChange={(e) => setSurveyData({...surveyData, title: e.target.value})}
            required
        />
      </div>

      <div className="questions-list mt-4">
        {surveyData.questions.map((q, qIndex) => (
            <div key={q.id} className="question-card bg-white p-3 rounded border mb-3 shadow-sm">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <span className="badge bg-secondary mb-2">Pregunta {qIndex + 1}</span>
                    <div className="d-flex align-items-center gap-3">
                        <select 
                            className="form-select form-select-sm" 
                            style={{width: 'auto'}}
                            value={q.type || 'radio'}
                            onChange={(e) => updateQuestion(q.id, 'type', e.target.value)}
                        >
                            <option value="radio">Opciones</option>
                            <option value="text">Texto</option>
                        </select>
                        <button type="button" className="btn btn-sm text-danger p-0" onClick={() => removeQuestion(q.id)} title="Eliminar pregunta">
                            <Trash2 size={16} />
                        </button>
                    </div>
                </div>
                
                <input 
                    type="text" 
                    className="form-control mb-3 fw-medium" 
                    placeholder="Escribe tu pregunta aquí..."
                    value={q.text}
                    onChange={(e) => updateQuestion(q.id, 'text', e.target.value)}
                    required
                />

                {(!q.type || q.type === 'radio') ? (
                    <div className="options-list ps-3 border-start border-2 border-primary border-opacity-25">
                        {q.options.map((opt, optIndex) => (
                            <div key={optIndex} className="d-flex align-items-center mb-2">
                                <div className="form-check me-2">
                                    <input className="form-check-input" type="radio" disabled />
                                </div>
                                <input 
                                    type="text" 
                                    className="form-control form-control-sm"
                                    value={opt}
                                    onChange={(e) => updateOption(q.id, optIndex, e.target.value)}
                                    required
                                />
                                {q.options.length > 2 && (
                                    <button type="button" className="btn btn-sm text-muted ms-1" onClick={() => removeOption(q.id, optIndex)}>
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                        ))}
                        <button 
                            type="button" 
                            className="btn btn-sm btn-link text-decoration-none p-0 mt-1 d-flex align-items-center"
                            onClick={() => addOption(q.id)}
                        >
                            <Plus size={14} className="me-1" /> Añadir opción
                        </button>
                    </div>
                ) : (
                    <div className="ps-3 border-start border-2 border-info border-opacity-25 py-2 text-muted small fst-italic">
                        El usuario responderá con texto libre.
                    </div>
                )}
            </div>
        ))}
      </div>

      <button 
        type="button" 
        className="btn btn-outline-primary btn-sm w-100 mt-2 border-dashed d-flex align-items-center justify-content-center py-2"
        onClick={addQuestion}
        style={{ borderStyle: 'dashed' }}
      >
        <Plus size={16} className="me-2" />
        Agregar Nueva Pregunta
      </button>

    </div>
  );
};

export default SurveyBuilder;
